import { render, staticRenderFns } from "./newpage1.vue?vue&type=template&id=0f3f809a&scoped=true&"
import script from "./newpage1.vue?vue&type=script&lang=js&"
export * from "./newpage1.vue?vue&type=script&lang=js&"
import style0 from "./newpage1.vue?vue&type=style&index=0&id=0f3f809a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3f809a",
  null
  
)

export default component.exports